import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface OutdoorStructuresProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const OutdoorStructures: React.FC<OutdoorStructuresProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [outdoorStructures, set_outdoorStructures] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Final Steps']?.['Outdoor Structures'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Final Steps': { ...b.values?.['Final Steps'], 'Outdoor Structures': v } } })
    );
    const label = 'Outdoor Structures (deck, patio, porches)';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(outdoorStructures)}
                />
            ) : (
                <MoneyBox
                    id={'outdoorStructures'}
                    allowNegative={false}
                    value={outdoorStructures}
                    onChange={(value) => set_outdoorStructures(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
